const SDK_VERSION = '8.2.0';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
